var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"interactive-list-item",class:{'expanded-item': _vm.isExpandedItem}},[_c(_vm.tableItemComponent,_vm._b({tag:"component",attrs:{"item":_vm.item}},'component',_vm.tableItemComponentProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }